export interface TextViewerVm {
    type: 'text';
    value: string;
}

export default function buildTextViewer(value: string): TextViewerVm {
    return { type: 'text', value };
}
